import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8f1e0a7c")
const _hoisted_1 = { class: "authorization-mask" }
const _hoisted_2 = { class: "authorization" }
const _hoisted_3 = { class: "authorization-container" }
const _hoisted_4 = { class: "authorization-container-head" }
const _hoisted_5 = { class: "showAuthMessage" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "请联系:400-887-3233处理", -1)
const _hoisted_7 = { class: "modalBtnContent" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["authorization-container-img", 
              _ctx.authResultType === 1
                ? 'unAuthorized'
                : _ctx.authResultType === 2
                ? 'outofdate'
                : 'isLimited'
            ])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.authResultMessage), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToLogin && _ctx.goToLogin(...args)))
          }, "确定")
        ])
      ])
    ])
  ]))
}